import { render, staticRenderFns } from "./ApprovalInfoModify.vue?vue&type=template&id=531866a4&scoped=true&"
import script from "./ApprovalInfoModify.vue?vue&type=script&lang=js&"
export * from "./ApprovalInfoModify.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalInfoModify.vue?vue&type=style&index=0&id=531866a4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531866a4",
  null
  
)

export default component.exports